// In development, use empty string to route through Vue dev server proxy
// In production, use the actual API URL
const host = process.env.NODE_ENV === 'development' 
  ? '' 
  : (process.env.VUE_APP_API_URL || '');

const apiBaseUrl = '/api/';

export { host, apiBaseUrl };
